import { OnboardingV3Status } from '~/utils/constant';
import { Dict } from '~/utils/dict';

export enum OnboardingV3Routes {
  ADD_PROPERTIES_AND_UNITS = 'add-properties-and-units',
  SETUP_LEASES = 'setup-leases',
  BUSINESS_BASIC_INFO = 'business-basic-info',
  PAYMENT_COLLECTION = 'payment-collection',
  TENANT_SCREENING = 'tenant-screening',
  INSURANCE = 'insurance',
  INSURANCE_DAMAGE_WAIVER = 'insurance-damage-waiver',
  PHONE_LINE_SETUP = 'phone-line-setup',
  TEXT_MESSAGE_ALERT = 'text-message-alert',
  SEND_INVITES = 'send-invites',
}

export const onboardingV3StepsDict = new Dict<OnboardingV3Status, { path: OnboardingV3Routes }>([
  {
    label: 'Add properties and units',
    value: OnboardingV3Status.V3_ADD_PROPERTIES_AND_UNITS,
    meta: {
      path: OnboardingV3Routes.ADD_PROPERTIES_AND_UNITS,
    },
  },
  {
    label: 'Setup leases',
    value: OnboardingV3Status.V3_SETUP_LEASES,
    meta: {
      path: OnboardingV3Routes.SETUP_LEASES,
    },
  },
  {
    label: 'Business information',
    value: OnboardingV3Status.V3_BUSINESS_BASIC_INFO,
    meta: {
      path: OnboardingV3Routes.BUSINESS_BASIC_INFO,
    },
  },
  {
    label: 'Payment collection',
    value: OnboardingV3Status.V3_PAYMENT_COLLECTION,
    meta: {
      path: OnboardingV3Routes.PAYMENT_COLLECTION,
    },
  },
  {
    label: 'Tenant screening',
    value: OnboardingV3Status.V3_TENANT_SCREENING,
    meta: {
      path: OnboardingV3Routes.TENANT_SCREENING,
    },
  },
  {
    label: 'Insurance',
    value: OnboardingV3Status.V3_INSURANCE,
    meta: {
      path: OnboardingV3Routes.INSURANCE,
    },
  },
  {
    label: 'Damage Waiver Program',
    value: OnboardingV3Status.V3_INSURANCE,
    meta: {
      path: OnboardingV3Routes.INSURANCE_DAMAGE_WAIVER,
    },
  },
  {
    label: 'Phone line setup',
    value: OnboardingV3Status.V3_PHONE_LINE_SETUP,
    meta: {
      path: OnboardingV3Routes.PHONE_LINE_SETUP,
    },
  },
  {
    label: 'Text message alert',
    value: OnboardingV3Status.V3_TEXT_MESSAGE_ALERT,
    meta: {
      path: OnboardingV3Routes.TEXT_MESSAGE_ALERT,
    },
  },
  {
    label: 'Send invites',
    value: OnboardingV3Status.V3_SEND_INVITES,
    meta: {
      path: OnboardingV3Routes.SEND_INVITES,
    },
  },
]);
